/*************/
/* ANIMATION */
/*************/

// add class .toAnimate to html element with a animate.css effect class
// when on screen, the animation will execute
$(function(){
	const mutationConfig = {
		childList: true,
		subtree: true
	};
	var newAnimationObserver = new MutationObserver(domNewContent);
	newAnimationObserver.observe(document, mutationConfig);
	
	function domNewContent(mutations){
		mutations.forEach(function(mutation){
			if(mutation.type == 'childList'){
				let addedNodes = mutation.addedNodes;
				
				if(addedNodes.length){ // Nouveau contenu ajouté
					checkAnimations();
				}
			}
		}); 
	}
});

$(window).on('load', function(event) {
	checkAnimations();

	var linkLoadedCount = 0;
	var totalPreloadLink = $('link[rel="preload"][as="style"]').length;

	// Ajoute un listener pour tous les style qui reste à loader.
	$('link[rel="preload"][as="style"]').one('load', function(){
		linkLoadedCount++;

		if(linkLoadedCount == totalPreloadLink){
			checkAnimations();
		}
	});

	// Après 5 secondes, on vérifie une dernière fois les animations.
	window.setTimeout(function(){
		checkAnimations();
	}, 5000);
});

$(window).on('scroll', function(event) {
	checkAnimations();
});

function checkAnimations(){
	if(!$('body').hasClass('preload')){
		script_on_load('theme-utils', function(){
			requestAnimationFrame(function() {
				$('.toAnimate').each(function(index, el) {
					if($(this).isOnScreen() === true){
						$(this).addClass('animated').removeClass('toAnimate');
						this.dispatchEvent(new CustomEvent('animated'));

						var elem_class = $(this).attr('class');
						var pos = elem_class.search('animS_');
						
						if(pos !== -1){
							var anim_name = elem_class.substring(pos, elem_class.indexOf(" ", pos));
							$(this).removeClass(anim_name);
							
							anim_name = anim_name.replace('animS_', '');
							
							$(this).addClass(anim_name);
						}
					}
				});
			});
		});
	}
}